import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  DistrictType,
  SeatType,
  UpazilaType,
  VideosType,
} from "../../../models";
import SelectComponent from "../../CommonComponent/SelectComponent";
import { getMemberList } from "../../../store/API/MemberApis";
import { Link } from "react-router-dom";

interface FormData {
  title: string;
  video_id: string;
  link: string;
  description: string;
  position: string;
  duration: string;
}

const labels: Record<string, string> = {
  title: "Title",
  video_id: "Video Id",
  link: "Video Link",
  description: "Description",
  position: "Position",
  duration: "Duration",
};

const NetaVideosCreateForm = ({
  onSubmit,
  details,
}: {
  onSubmit: Function;
  details?: VideosType | null;
}) => {
  const { division, district, upazila, seat } = useAppSelector(
    (state) => state.common
  );
  const { memberList } = useAppSelector((state) => state.member);
  console.log(memberList, "memberList");

  const [formData, setFormData] = useState<FormData>({
    title: "",
    video_id: "",
    link: "",
    description: "",
    position: "",
    duration: "",
  });
  const [thumbnail, setThumbnail] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setThumbnail(file); // Set the profilePic state separately
  };

  const dispatch = useAppDispatch();
  const [divisionData, setDivisionData] = useState<{
    value: number;
    label: string;
  } | null>(null);
  const [districtData, setDistrictData] = useState<{
    value: number;
    label: string;
  } | null>(null);
  const [upazilaData, setUpazilaData] = useState<
    { value: number; label: string }[]
  >([]);
  const [seatData, setSeatData] = useState<{
    value: number;
    label: string;
  } | null>(null);
  const [memberData, setMemberData] = useState<{
    value: number;
    label: string;
  } | null>(null);
  const [videoTypeData, setVideoTypeData] = useState<{
    value: number;
    label: string;
  } | null>(null);

  const [divisionOption, setDivisionOption] = useState<
    { value: number; label: string }[]
  >([]);
  const [districtOption, setDistrictOption] = useState<
    { value: number; label: string }[]
  >([]);
  const [upazilaOption, setUpazilaOption] = useState<
    { value: number; label: string }[]
  >([]);
  const [seatOption, setSeatOption] = useState<
    { value: number; label: string }[]
  >([]);
  const [memberOption, setMemberOption] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    if (details) {
      setFormData({
        ...formData,
        title: details.title,
        description: details?.description,
        duration: String(details?.duration) || "",
        link: details.link,
        position: details.position || "",
        video_id: details.video_id,
      });
      if (details.member) {
        setMemberData({
          label: String(details.member.name),
          value: details.member.id,
        });
      }
      if (details.videoType) {
        setVideoTypeData({
          label: details.videoType,
          value: details.videoType === "YOUTUBE" ? 1 : 2,
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  useEffect(() => {
    setDivisionOption(
      division?.map((item: any) => ({ value: item.id, label: item.name })) || []
    );
  }, [division]);

  useEffect(() => {
    setDistrictOption(
      district?.map((item: any) => ({ value: item.id, label: item.name })) || []
    );
  }, [district]);

  useEffect(() => {
    setUpazilaOption(
      upazila?.map((item: any) => ({ value: item.id, label: item.name })) || []
    );
  }, [upazila]);

  useEffect(() => {
    setSeatOption(
      seat?.map((item: any) => ({ value: item.id, label: item.name })) || []
    );
  }, [seat]);

  useEffect(() => {
    setMemberOption(
      memberList?.results?.members?.map((item: any) => ({
        value: item.id,
        label: item.name,
      })) || []
    );
  }, [memberList]);

  const handleDivisionSelectChange = (selectedOption: any) => {
    setDivisionData(selectedOption);
    setDistrictData(null);
    // setUpazilaData([]);
    setSeatData(null);
    const filteredDistricts = selectedOption
      ? district.filter(
          (item: DistrictType) => item.division.id === selectedOption.value
        )
      : district;
    setDistrictOption(
      filteredDistricts.map((item: any) => ({
        value: item.id,
        label: item.name,
      }))
    );
  };

  const handleDistrictSelectChange = (selectedOption: any) => {
    setDistrictData(selectedOption);
    // setUpazilaData([]);
    setSeatData(null);
    const filteredUpazila = selectedOption
      ? upazila.filter(
          (item: UpazilaType) => item.district.id === selectedOption.value
        )
      : upazila;
    setUpazilaOption(
      filteredUpazila.map((item: any) => ({ value: item.id, label: item.name }))
    );
  };

  const handleUpazilaSelectChange = (selectedOptions: any) => {
    // setUpazilaData(selectedOptions || []);
    setSeatData(null);
    const filteredSeat = selectedOptions.length
      ? seat.filter((item: SeatType) =>
          selectedOptions.some((upazila: { value: number }) =>
            item.upazila.includes(upazila.value)
          )
        )
      : seat;
    setSeatOption(
      filteredSeat.map((item: any) => ({ value: item.id, label: item.name }))
    );
  };

  const handleSeatSelectChange = (selectedOption: any) => {
    setSeatData(selectedOption);
  };

  const handleMemberSelectChange = (selectedOption: any) => {
    setMemberData(selectedOption);
  };

  const handleVideoTypeSelectChange = (selectedOption: any) => {
    setVideoTypeData(selectedOption);
  };

  const handleSubmit = async () => {
    onSubmit(formData, memberData, videoTypeData, thumbnail);
  };

  const handleSearchMember = () => {
    dispatch(
      getMemberList({
        division: divisionData?.value,
        district: districtData?.value,
        upazila: upazilaData.map((item) => item.value),
        seat: seatData?.value,
        page: 1,
        page_size: 100,
      })
    );
  };
  return (
    <div className="p-6">
      <div className="mb-4 flex flex-col xl:flex-row gap-6 items-end">
        <div className="w-full xl:w-1/3">
          <label className="mb-2 block text-black dark:text-white">
            Division
          </label>
          <SelectComponent
            selectOptions={divisionOption}
            selectData={divisionData ?? undefined}
            setSingleSelectData={setDivisionData}
            handleSelectChange={handleDivisionSelectChange}
            placeholder="Choose Your Division"
            clearable={false}
            searchable={true}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <label className="mb-2 block text-black dark:text-white">
            District
          </label>
          <SelectComponent
            selectOptions={districtOption}
            selectData={districtData ?? undefined}
            setSingleSelectData={setDistrictData}
            handleSelectChange={handleDistrictSelectChange}
            placeholder="Choose Your District"
            clearable={false}
            searchable={true}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <label className="mb-2 block text-black dark:text-white">
            Upazila
          </label>
          <SelectComponent
            selectOptions={upazilaOption}
            selectData={upazilaData}
            setMultiSelectData={setUpazilaData}
            handleSelectChange={handleUpazilaSelectChange}
            placeholder="Choose Your Upazila"
            clearable={false}
            searchable={true}
            isMultiple={true}
          />
        </div>
      </div>
      <div className="mb-4 flex flex-col xl:flex-row gap-6 items-end">
        <div className="w-full xl:w-1/3">
          <label className="mb-2 block text-black dark:text-white">Seat</label>
          <SelectComponent
            selectOptions={seatOption}
            selectData={seatData}
            setSingleSelectData={setSeatData}
            handleSelectChange={handleSeatSelectChange}
            placeholder="Choose Your Seat"
            clearable={false}
            searchable={true}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <label className="mb-2 block text-black dark:text-white">Seat</label>
          <SelectComponent
            selectOptions={seatOption}
            selectData={seatData}
            setSingleSelectData={setSeatData}
            handleSelectChange={handleSeatSelectChange}
            placeholder="Choose Your Seat"
            clearable={false}
            searchable={true}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <button
            onClick={handleSearchMember}
            className="inline-flex items-center justify-center rounded bg-primary px-6 py-2 font-medium bg-blue-500 text-white hover:bg-opacity-90"
          >
            Search Member
          </button>
        </div>
      </div>

      <div className="mb-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="w-full">
          <label className="mb-2 block text-black dark:text-white">
            Member
          </label>
          <SelectComponent
            selectOptions={memberOption}
            selectData={memberData}
            setSingleSelectData={setMemberData}
            handleSelectChange={handleMemberSelectChange}
            placeholder="Choose Your Member"
            clearable={false}
            searchable={true}
          />
        </div>
        <div className="w-full">
          <label className="mb-2 block text-black dark:text-white">
            Video Type
          </label>
          <SelectComponent
            selectOptions={[
              { value: 1, label: "YOUTUBE" },
              { value: 2, label: "FACEBOOK" },
            ]}
            selectData={videoTypeData}
            setSingleSelectData={setVideoTypeData}
            handleSelectChange={handleVideoTypeSelectChange}
            placeholder="Choose Video Type"
            clearable={false}
            searchable={true}
          />
        </div>
        {Object.keys(formData).map((field) => (
          <div key={field} className="w-full">
            <label className="mb-2 block text-black dark:text-white">
              {labels[field] || field.split(/(?=[A-Z])/).join(" ")}
            </label>
            <input
              type="text"
              value={formData[field as keyof FormData] || ""}
              onChange={(e) =>
                setFormData({ ...formData, [field]: e.target.value })
              }
              placeholder={`Enter ${labels[field] || field}`}
              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
            />
          </div>
        ))}

        <div className="w-full">
          <label className="mb-2 block text-black dark:text-white">
            Thumbnail
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full py-3"
          />
          <strong className="mt-2">
            {details?.thumbnail ? (
              <Link
                to={details?.thumbnail}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Thumbnail
              </Link>
            ) : (
              "N/A"
            )}
          </strong>
        </div>

        <div className="mb-4">
          <button
            onClick={handleSubmit}
            className="w-full rounded bg-blue-600 py-3 text-white hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300"
          >
            Submit
          </button>
        </div>
        {/* <div className="w-full">
                <label className="mb-2 block text-black dark:text-white">
                  Cover Picture
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleCoverFileChange}
                  className="w-full py-3"
                />
                <strong className="mt-2">
                  {details?.cover_pic ? (
                    <Link
                      to={details?.cover_pic}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open Cover Picture
                    </Link>
                  ) : (
                    "N/A"
                  )}
                </strong>
              </div> */}
      </div>
    </div>
  );
};

export default NetaVideosCreateForm;
